import { socialLinks } from "../data/socialLinks";
import SocialIcon from "./SocialIcon";

const variantClasses = {
  header: "border border-neutral-200 bg-white text-neutral-800 shadow-sm hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700",
  hero: "border border-blue-200 bg-white/90 text-blue-700 shadow-sm hover:border-blue-300 hover:bg-blue-50",
  light: "border border-neutral-200 bg-white text-neutral-900 shadow-sm hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700",
  footer: "border border-white/10 bg-white/[0.08] text-white hover:border-cyan-300/40 hover:bg-white/[0.14]",
  contact: "border border-neutral-200 bg-white text-neutral-900 shadow-sm hover:border-blue-200 hover:bg-blue-50 hover:text-blue-700"
};

const socialIds = new Set(["linkedin", "x", "instagram", "tiktok", "youtube", "facebook", "threads", "bilibili"]);

export default function SocialLinks({
  variant = "light",
  compact = false,
  className = "",
  primaryOnly = false,
  onLinkClick
}) {
  const base = variantClasses[variant] || variantClasses.light;
  const socialItems = socialLinks.filter((link) => socialIds.has(link.id));
  const actionItems = primaryOnly
    ? []
    : socialLinks.filter((link) => !socialIds.has(link.id));

  return (
    <div className={`w-full min-w-0 max-w-full overflow-hidden ${className}`} data-social-links>
      <div className="mx-auto grid w-full max-w-xl grid-cols-4 gap-2 overflow-hidden px-0.5 sm:grid-cols-8 sm:gap-3">
        {socialItems.map((link) => (
          <a
            key={link.id}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Open TechniaHQRobot on ${link.name || link.shortLabel}`}
            title={link.name || link.shortLabel || link.label}
            onClick={onLinkClick}
            className={`focus-ring grid aspect-square w-full max-w-12 min-w-0 place-items-center justify-self-center rounded-full p-0 transition ${base}`}
          >
            <SocialIcon id={link.id} className="h-5 w-5 sm:h-[22px] sm:w-[22px]" />
            <span className="sr-only">TechniaHQRobot on {link.name || link.shortLabel}</span>
          </a>
        ))}
      </div>

      {actionItems.length > 0 && (
        <div className="mt-4 flex w-full max-w-full flex-row flex-wrap items-center justify-center gap-2.5 overflow-hidden">
          {actionItems.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={link.label}
              title={link.description}
              onClick={onLinkClick}
              className={`focus-ring inline-flex min-h-10 max-w-full items-center justify-center whitespace-nowrap rounded-full px-4 py-2 text-sm font-bold transition ${base}`}
            >
              <span className="truncate whitespace-nowrap">
                {compact ? link.shortLabel : link.label}
              </span>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}
